const name = 'circle-b';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M32.911 26.829c2.983 0 5.22.649 6.712 1.947 1.491 1.298 2.237 3.08 2.237 5.344 0 3.204-1.768 5.248-5.303 6.131v.415c2.044.442 3.618 1.201 4.723 2.278s1.657 2.527 1.657 4.35c0 2.376-.787 4.254-2.361 5.635C39 54.309 36.723 55 33.74 55H21.063V26.829H32.91zm-.165 16.074h-6.049v7.457h6.38c1.27 0 2.293-.29 3.066-.87.773-.58 1.16-1.533 1.16-2.859 0-2.485-1.52-3.728-4.557-3.728zm-.249-11.434h-5.8v6.794h5.8c2.652 0 3.977-1.133 3.977-3.397 0-2.265-1.325-3.397-3.977-3.397z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'B',
};

export default icon;
